import styled from "styled-components";
//components
import { Row } from "components/Layout/Grid";
import Text from "components/Text";
import { Button } from "components/Button";

interface ITooltipItem {
  isRead?: boolean;
}

export const Space = styled(Row)`
  padding: 0.8em;
  height: 50px;
  align-items: center;
`;

export const Tag = styled.div`
  width: 20px;
  height: 16px;
  margin-right: 4px;
  padding-right: 4px;
  padding-left: 4px;

  font-size: 11px;
  font-weight: 600;
  border-radius: 4px;
  background-color: #f9b609;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ToogleContainer = styled.label`
  display: flex;
  justify-content: center;
`;

export const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const TooltipItemNotParticipate = styled.span<ITooltipItem>`
  visibility: hidden;
  background-color: #ffffff;

  width: auto;
  border: 1px solid #f2f3f4;

  border-radius: 6px;
  position: absolute;
  z-index: 1000000;
  padding: 7px 11px;
  left: -180%;
  bottom: 52%;
  transform: translateX(94%);
  opacity: 94%;

  color: ${(props) => (props.isRead ? "#858585" : "#364863")};
  font-family: "Lato", sans-serif;
  font-size: 12px;
  font-weight: ${(props) => (props.isRead ? "400" : "700")};
  text-align: left;

  ${TooltipContainer}:hover & {
    visibility: visible;
  }
`;

export const TooltipPreOrderIcon = styled.span<ITooltipItem>`
  visibility: hidden;
  background-color: #ffffff;

  width: 180px;
  border: 1px solid #f2f3f4;

  border-radius: 6px;
  position: absolute;
  z-index: 1000000;
  padding: 7px 11px;
  left: -180%;
  bottom: 52%;
  opacity: 94%;

  color: ${(props) => (props.isRead ? "#858585" : "#364863")};
  font-family: "Lato", sans-serif;
  font-size: 12px;
  font-weight: ${(props) => (props.isRead ? "400" : "700")};
  text-align: left;

  ${TooltipContainer}:hover & {
    visibility: visible;
  }
`;

export const ButtonIndicatorFilter = styled.button`
  border: none;
  cursor: pointer;
  margin-left: 8px;
`;

export const CustomIcon = styled.img`
  margin-top: 3px;
`;

export const CompanyNameContainer = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 165px;
`;

export const CompanyNameTooltip = styled(Text)`
  font-size: 12px !important;
`;

export const CustomButton = styled(Button)`
  padding-left: 0;
  padding-right: 10px;
`;